import Vue from 'vue';

window.APM && window.APM.init({
  // 应用ID，必填
  appId: 'o1VxDnwT',
  // 业务名称，必填
  appName: 'WPS学堂',
  // 业务版本号
  appVersion: process.env.VERSION,
  // 采样率
  samplingRate: process.env.NODE_ENV !== 'production' ? 1 : 10,
  // 是否开启debug模式，是则在控制台输出日志
  isDebug: process.env.NODE_ENV !== 'production' ? true : false,
  // 插件配置 - 开关策略、采样率
  pluginConfig: {
    // 性能插件配置
    performance: { switch: true },
    // 业务日志插件配置
    businessLogger: { switch: true },
    // vue框架错误捕获插件
    vue: { vue: Vue, switch: true },
    // js异常错误捕获插件
    windowOnError: { switch: true },
    // web资源异常捕获插件
    windowSourceError: { switch: true },
    // promise异常捕获插件
    windowUnhandledRejection: { switch: true },
  }
});
